import { readPublicContact, readPublicSiteConfig, readPublicSocial, readPublicSupporters } from './public';

let sharedMetadataPromise;

export const clearPublicMetadataCache = () => {
  sharedMetadataPromise = null;
};

export const readPublicMetadata = async () => {
  if (!sharedMetadataPromise) {
    sharedMetadataPromise = Promise.all([
      readPublicSiteConfig(),
      readPublicSocial(),
      readPublicContact(),
    ]).then(([siteConfig, social, contact]) => ({
      email: contact.email,
      social,
      supportersUrl: siteConfig.supportersUrl,
      characterSheetsBaseUrl: siteConfig.characterSheetsBaseUrl,
      disqus: siteConfig.disqus,
    }));
  }

  return sharedMetadataPromise;
};

export const readPublicSupportersPage = async () => {
  const supportersPage = await readPublicSupporters();

  return {
    supportUrl: supportersPage.supportUrl,
    supporters: supportersPage.supporters || [],
  };
};
